/* unplugin-vue-components disabled */import script from "./WORoleProps.vue?vue&type=script&setup=true&lang=js"
export * from "./WORoleProps.vue?vue&type=script&setup=true&lang=js"

import "./WORoleProps.vue?vue&type=style&index=0&id=032f4ff9&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032f4ff9"]])

export default __exports__